<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-09-14 12:01:36
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-26 10:23:56
 * @FilePath: \合联\oms\src\view\system\city\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  getCity,
  add,
  del,
  update,
  getDetails,
  getFinaDivision,
  sync,
  setRegions,
  setRemoteDepth,
  uploadFile,
  setTemuPartition,
  ageing
} from "@/api/system/city";
import { getCountry } from "@/api/system/country";
import { getAirport } from "@/api/system/circuit";
import cTable from "@/base/common/index";
export default {
  name: "city",

  components: {
    cTable
  },
  data() {
    return {
      selectData: {},
      country_id: "",
      methods: {
        list: p => {
          this.country_id = p.country_id;
          return getCity(p);
        },
        getDetails,
        del,
        add,
        update,
        getCountry,
        getFinaDivision,
        sync,
        setRegions,
        setRemoteDepth,
        uploadFile,
        setTemuPartition,
        ageing
      },
      config: {
        height: 630
      },
      modals: {
        ageing: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData();
              this.$page
                .handleRequestMethods("ageing", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("TM,城市,时效"),
            modalBind: {
              width: 800
            },
            formBind: {
              labelWidth: 200
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              country_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ]
            }
          },
          grid: [
            { country_id: 24 },
            { tm_ageing: 24 },
            { ccd_clearance_ageing: 24 },
            { ccd_ppd_ageing: 24 },
            { ccd_cod_ageing: 24 }
          ],
          fields: [
            {
              name: this.$tz("国家"),
              key: "country_id",
              component: "Select",
              placeholder: () => this.$tz("国家"),
              options: [],
              optionsFn: "toCountryID",
              optionsKey: "",
              default: ""
            },
            {
              name: () => this.$tz("TM,全段,时效"),
              key: "tm_ageing",
              component: "Input",
              placeholder: () => this.$tz("TM,全段,时效")
            },
            {
              name: () => this.$tz("TM,拆段,清关,时效"),
              key: "ccd_clearance_ageing",
              component: "Input",
              placeholder: () => this.$tz("TM,拆段,清关,时效")
            },
            {
              name: () => this.$tz("TM,拆段,PP,签收,时效"),
              key: "ccd_ppd_ageing",
              component: "Input",
              placeholder: () => this.$tz("TM,拆段,PP,签收,时效")
            },
            {
              name: () => this.$tz("TM,拆段,COD,首派,时效"),
              key: "ccd_cod_ageing",
              component: "Input",
              placeholder: () => this.$tz("TM,拆段,COD首派时效")
            }
          ]
        },
        temu: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({
                ids: row.ids,
                country_id: row.country_id
              });
              this.$page
                .handleRequestMethods("setTemuPartition", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ partition: 24 }],
          fields: [
            {
              name: this.$tz("城市分区"),
              key: "partition",
              component: "Radio",
              options: [
                { value: 0, label: this.$tz("不分区") },
                { value: 1, label: "T1" },
                { value: 2, label: "T2" },
                { value: 3, label: "T3" }
              ],
              default: 0,
              optionsFn: "",
              optionsKey: "",
              bind: {
                border: true
              }
            }
          ]
        },
        upload: {
          methods: {
            ok() {
              window.open(this.$globalUrl + "/doc/zh-CN/city.xlsx", "_black");
            }
          },
          footer: {
            cancel: {
              isShow: true
            },
            ok: {
              name: this.$t("download_tem")
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false
            },
            rowBind: {
              gutter: 16
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files")
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx"
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  let _this = this.$refs["table"];
                  _this
                    .handleRequestMethods("uploadFile", formData)
                    .then(res => {
                      _this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      _this.getModal("upload").close();
                    });
                  return false;
                }
              }
            }
          ]
        },
        degree: {
          type: "add",
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("setRemoteDepth", row, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("设置,偏远程度"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              remote_depth: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [{ remote_depth: 24 }],
          fields: [
            {
              name: this.$tz("偏远程度"),
              key: "remote_depth",
              component: "Select",
              placeholder: () => this.$tz("偏远程度"),
              options: [],
              optionsFn: "remoteDepth",
              optionsKey: "",
              default: ""
            }
          ]
        },
        batch: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ ids: row.ids });
              this.$page
                .handleRequestMethods("setRegions", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("设置,是否偏远地区"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              remote_regions: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [{ remote_regions: 24 }],
          fields: [
            {
              name: this.$tz("是否偏远地区"),
              key: "remote_regions",
              component: "Radio",
              options: [
                { value: 1, label: this.$tz("是") },
                { value: -1, label: this.$tz("否") }
              ],
              optionsFn: "",
              optionsKey: "",
              bind: {
                border: true
              }
            }
          ]
        },
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16
            },
            colBind: {
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "city_name cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum length 55",
                  trigger: "blur"
                }
              ],
              code: [
                {
                  required: true,
                  message: "city_code cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 255,
                  message: "Please enter maximum length 255",
                  trigger: "blur"
                }
              ],
              zipcode: [
                {
                  required: true,
                  message: "zip_code cannot be empty",
                  trigger: "blur"
                }
              ],
              country_id: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the country",
                  trigger: "change"
                }
              ],
              status: [
                {
                  required: true,
                  message: "Please select the status",
                  trigger: "change"
                }
              ],
              remote_regions: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the remote_regions",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            {
              title: 12,
              source_title: 12,
              province: 12,
              area: 12,
              code: 12,
              circuit_id: 12,
              smsa_code: 12,
              zipcode: 12,
              country_id: 12,
              status: 12,
              remote_regions: 12,
              division: 12,
              face_code: 12,
              tm_ageing: 12,
              ccd_clearance_ageing: 12,
              ccd_ppd_ageing: 12,
              ccd_cod_ageing: 12,
              is_cod: 12,
              remarks: 12
            }
          ],
          fields: [
            {
              name: () => this.$tz("拆段,清关,时效"),
              key: "ccd_clearance_ageing",
              component: "Input",
              placeholder: () => this.$tz("拆段,清关,时效")
            },
            {
              name: () => this.$tz("拆段,预付件,签收,时效"),
              key: "ccd_ppd_ageing",
              component: "Input",
              placeholder: () => this.$tz("拆段,预付件,签收,时效")
            },
            {
              name: () => this.$tz("拆段,到付件,首派,时效"),
              key: "ccd_cod_ageing",
              component: "Input",
              placeholder: () => this.$tz("拆段,到付件,首派,时效")
            },
            {
              name: () => this.$tz("TM,时效"),
              key: "tm_ageing",
              component: "Input",
              placeholder: () => this.$tz("TM,时效")
            },
            {
              name: () => this.$tz("别称"),
              key: "source_title",
              component: "Input",
              placeholder: () => this.$tz("别称")
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 2
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              }
            },
            {
              name: () => this.$t("city_name"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("city_name");
              }
            },
            {
              name: () => this.$t("province"),
              key: "province",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("province");
              }
            },
            {
              name: () => this.$t("area"),
              key: "area",

              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("area");
              }
            },
            {
              name: () => this.$t("city_code"),
              key: "code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("city_code");
              }
            },
            {
              name: () => this.$t("circuit"),
              key: "circuit_id",
              component: "Select",
              options: [],
              config: {
                label: "circuit",
                value: "id"
              },
              placeholder() {
                return this.$t("enter") + this.$t("circuit");
              }
            },
            {
              name: () => "smsa" + this.$t("city_code"),
              key: "smsa_code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + "smsa" + this.$t("city_code");
              }
            },
            {
              name: () => this.$t("zip_code"),
              key: "zipcode",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("zip_code");
              }
            },
            {
              name: () => this.$t("countryName"),
              key: "country_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("countryName");
              },
              options: [],
              config: { label: "title", value: "id" },
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData[field.key];
                  this.$forceUpdate();
                },
                "on-change"({ row, fields }) {
                  fields.forEach(async item => {
                    if (item.key == "division") {
                      row["division"] = "";
                      item.options = [];
                    }
                    this.$forceUpdate();
                  });
                },
                click({ obj, fields, row }) {
                  fields.forEach(async item => {
                    if (item.key == "division") {
                      row["division"] = "";
                      item.options = (
                        await this.$page.handleRequestMethods(
                          "getFinaDivision",
                          { country: obj.code }
                        )
                      ).payload;
                    }
                    this.$forceUpdate();
                  });
                }
              }
            },
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              options: [],
              bind: {
                border: true
              },
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData[field.key];
                  this.$forceUpdate();
                }
              },
              default: "ENABLE"
            },
            {
              name: () => this.$t("remote_regions"),
              key: "remote_regions",
              component: "Radio",
              options: [],
              bind: {
                border: true
              },
              methods: {
                list: ({ field }) => {
                  field.options = this.selectData[field.key];
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("division"),
              key: "division",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("division");
              },
              options: []
            },
            {
              name: () => this.$t("SupportCod"),
              key: "is_cod",
              component: "Radio",
              bind: {
                border: true
              },
              placeholder() {
                return this.$t("select") + this.$t("SupportCod");
              },
              default: 0,
              options: [
                { value: 1, label: this.$t("YES") },
                { value: 0, label: this.$t("NO") }
              ]
            },
            {
              name: () => this.$t("sheet") + this.$t("code"),
              key: "face_code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("sheet") + this.$t("code");
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "country_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("countryName");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "circuit_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("circuit");
            },
            clearable: true,
            options: [],
            config: { label: "circuit", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "remote_regions",
            component: "Select",
            placeholder() {
              return this.$t("remote_regions");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "is_cod",
            component: "Select",
            placeholder() {
              return this.$t("SupportCod");
            },
            clearable: true,
            options: [
              { value: 1, label: this.$t("YES") },
              { value: 0, label: this.$t("NO") }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 144
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: () => this.$t("SyncOrderTemplate"),
              type: "sync",
              fnName: "sync",
              id: 1645,
              bind: {
                // icon: "md-checkmark",
                type: "primary"
              }
            },
            {
              name: () => this.$tz("设置,是否偏远地区"),
              type: "batch",
              fnName: "batch",
              bind: {
                type: "primary"
              },
              id: 1797,
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$tz("设置,偏远程度"),
              type: "degree",
              fnName: "degree",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              },
              id: 1801
            },
            {
              name: () => this.$tz("批量,导入"),
              type: "import",
              fnName: "import",
              bind: {
                type: "primary"
              },
              id: 1820
            },
            {
              name: () => this.$tz("TEMU,城市分区"),
              type: "temu",
              fnName: "temu",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("TM城市时效"),
              type: "ageing",
              fnName: "ageing",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            ageing() {
              this.getModal("ageing").open(null, function() {
                this.setTitle(this.$tz("TM,城市,时效"));
              });
            },
            temu: () => {
              if (!this.country_id) {
                return this.$Message.error(
                  this.$tz("请先搜索国家后再进行操作")
                );
              }
              let page = this.$refs["table"];
              let modal = page.getModal("temu");
              modal.open(
                {
                  ids: page.selectAll.map(t => t.id),
                  country_id: this.country_id
                },
                function() {
                  this.setTitle(this.$tz("TEMU,城市分区"));
                }
              );
            },
            import() {
              this.getModal("upload").open(null, function() {
                this.setTitle(this.$tz("批量,导入"));
              });
            },
            degree() {
              this.getModal("degree").open(
                { ids: this.selectAll.map(t => t.id) },
                function() {
                  this.setTitle(this.$tz("设置,偏远程度"));
                }
              );
            },
            batch() {
              this.getModal("batch").open(
                { ids: this.selectAll.map(t => t.id) },
                function() {
                  this.setTitle(this.$tz("设置,是否偏远地区"));
                }
              );
            },
            sync() {
              this.handleRequestMethods("sync", {}, true, true).then(res => {
                this.getList();
              });
            },
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: () => this.$t("city_name"),
          key: "title",
          align: "left",
          minWidth: 100,
          tooltip: true
        },
        {
          name: () => this.$tz('城市,等级'),
          key: 'level',
          minWidth: 110,
        },
        {
          name: () => this.$tz("别称"),
          key: "source_title",
          minWidth: 80
        },
        {
          name: () => this.$t("province"),
          key: "province",
          minWidth: 80
        },
        {
          name: () => this.$t("area"),
          key: "area",
          minWidth: 80
        },
        {
          name: () => this.$t("city_code"),
          key: "code",
          minWidth: 100
        },
        {
          name: () => this.$t("circuit"),
          key: "circuit",
          minWidth: 100
        },
        {
          name: () => this.$t("zip_code"),
          key: "zipcode",
          minWidth: 100
        },
        {
          name: () => this.$t("SupportCod"),
          key: "is_cod",
          minWidth: 100,
          methods: {
            render({ value }) {
              return this.$t(value ? "YES" : "NO");
            }
          }
        },
        {
          name: () => this.$t("countryCode"),
          key: "country",
          minWidth: 100,
          methods: {
            render({ row }) {
              return row.country ? row.country.title : "-";
            }
          }
        },
        {
          name: () => this.$t("remote_regions"),
          key: "remote_regions",
          minWidth: 100,
          methods: {
            render: ({ value, field }) => {
              return (
                this.selectData &&
                this.selectData[field.key] &&
                this.selectData[field.key].find(item => item.value == value)
                  .label
              );
            }
          }
        },
        {
          name: () => this.$tz("偏远程度"),
          key: "remote_depth_txt",
          minWidth: 110
        },
        {
          name: () => this.$t("exlType"),
          key: "status",
          minWidth: 110,
          methods: {
            render: ({ value, field }) => {
              return (
                this.selectData &&
                this.selectData[field.key] &&
                this.selectData[field.key].find(item => item.value == value)
                  .label
              );
            }
          }
        },
        {
          name: () => this.$t("division"),
          key: "division",
          minWidth: 110
        },
        {
          name: () => this.$tz("TEMU,分区"),
          key: "temu_position",
          minWidth: 110
        },
        {
          name: () => this.$tz("TM,时效"),
          key: "tm_ageing",
          minWidth: 110
        },
        {
          name: () => this.$tz('Tier,时效'),
          key: 'tier',
          minWidth: 110,
        },
        {
          name: () => this.$tz("拆段,清关,时效"),
          key: "ccd_clearance_ageing",
          minWidth: 110
        },
        {
          name: () => this.$tz("拆段,预付件,签收,时效"),
          key: "ccd_ppd_ageing",
          minWidth: 110
        },
        {
          name: () => this.$tz("拆段,到付件,首派,时效"),
          key: "ccd_cod_ageing",
          minWidth: 110
        },
        {
          name: () => this.$t("createTime"),

          key: "create_time",
          minWidth: 160,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("upTime"),

          key: "update_time",
          minWidth: 160,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          align: "left",
          width: 130
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 145
            }
            // {
            //   name: this.$t("delete"),
            //   type: "delete",
            //   fnName: "delete",
            //   bind: {
            //     type: "error"
            //   }
            // }
          ],

          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload, function() {
                  console.log(this);
                  this.fields.forEach(async item => {
                    if (item.key == "division") {
                      if (item.key == "division") {
                        item.options = (
                          await this.$page.handleRequestMethods(
                            "getFinaDivision",
                            { country: res.payload.country.code }
                          )
                        ).payload;
                      }
                      this.$forceUpdate();
                    }
                  });
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  async mounted() {
    this.selectData = {
      country_id: (await getCountry()).data.payload.rows,
      circuit_id: (await getAirport({ size: 9999 })).data.payload.rows,
      remote_regions: [
        { label: this.$t("YES"), value: 1 },
        { label: this.$t("NO"), value: 0 }
      ],
      status: [
        { label: this.$t("enable"), value: "ENABLE" },
        { label: this.$t("disable"), value: "DISABLE" }
      ]
    };
    this.header.searchs.forEach(async item => {
      if (item.key && this.selectData[item.key])
        item.options = this.selectData[item.key];
    });
    this.modals.add.fields.forEach(async item => {
      if (item.key && this.selectData[item.key])
        item.options = this.selectData[item.key];
    });
  }
};
</script>
